import React from 'react';
import { FONT_MONO, FONT_SANS, IMG } from '../../views/landing/landingData';
import { useLandingTheme } from '../../views/landing/useLandingTheme';
import '../../views/landing/landing.css';

/**
 * Full-page state shown while the session is checked (refresh on a protected
 * page) or an OAuth callback is completed. Wears the landing's desk background
 * and follows its light/dark choice so a reload doesn't flash a foreign colour.
 */
export const AuthScreen: React.FC<{ label: string; detail?: string; error?: boolean }> = ({ label, detail, error }) => {
    const [theme] = useLandingTheme();
    const isLight = theme === 'light';
    return (
        <div className="hv-root" data-hv-theme={theme} role="status" aria-live="polite" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, fontFamily: FONT_SANS, background: 'var(--hv-page)', color: 'var(--hv-ink)' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 18, textAlign: 'center' }}>
                <div style={{ position: 'relative', width: 56, height: 56, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {!error && <span aria-hidden="true" style={{ position: 'absolute', inset: 0, borderRadius: 999, border: '2px solid var(--hv-line)', borderTopColor: 'var(--hv-leaf)', animation: 'hvSpin 0.9s linear infinite' }} />}
                    <img src={isLight ? IMG.logoLight : IMG.logoDark} alt="HyVay" style={{ height: 26, width: 26, display: 'block', objectFit: 'cover', mixBlendMode: isLight ? 'multiply' : undefined }} />
                </div>
                <div style={{ fontFamily: FONT_MONO, fontSize: 10.5, letterSpacing: '0.06em', textTransform: 'uppercase', color: error ? 'var(--hv-danger)' : 'var(--hv-muted)' }}>{label}</div>
                {detail && <p style={{ margin: 0, maxWidth: 360, fontSize: 14, lineHeight: 1.6, color: 'var(--hv-body)' }}>{detail}</p>}
            </div>
        </div>
    );
};
